import { Schedule } from './schedule';
import { Position } from './position';
import { JobStatus } from '../enums/jobStatus';
import { JobType } from '../enums/jobType';

import * as _ from 'lodash';

export class Job {
    public id: string;
    public userId: string;
    public name: string;
    public jobType: JobType;
    public projectId: string;
    public sharingKey: string;

    public start: Date;
    public end: Date;
    public timeZoneId: string;
    public schedule: Schedule;

    public locations: Position[];
    public minimumSectionLength: number;
    public routePolyline: string;
    public routeLength: number;

    public startAddress: string;
    public endAddress: string;

    public status: JobStatus;
    public cost: number;
    public archived: boolean;
    public createdAt: Date;
    public finishedAt: Date;
    public usesTomTomData: boolean;

    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            this.id = json.id;
            this.userId = json.userId;
            this.name = json.name;
            this.jobType = json.jobType;
            this.projectId = json.projectId;
            this.sharingKey = json.sharingKey;
            this.start = this.convertTime(new Date(json.start));
            this.end = this.convertTime(new Date(json.end));
            this.timeZoneId = json.timeZoneId;
            this.schedule = new Schedule(json.schedule);
            this.locations = !_.isEmpty(json.locations) ? json.locations.map((posJson: any) => new Position(posJson)) : [];
            this.minimumSectionLength = json.minimumSectionLength;
            this.routePolyline = json.routePolyline;
            this.routeLength = json.routeLength;
            this.status = json.status;
            this.cost = json.cost;
            this.createdAt = json.createdAt ? new Date(json.createdAt) : undefined;
            this.startAddress = json.startAddress;
            this.endAddress = json.endAddress;
            this.archived = json.archived;
            this.finishedAt = json.finishedAt;
            this.usesTomTomData = json.usesTomTomData;
        }
    }

    private convertTime(date: Date): Date {
        let converted = new Date(date);
        let offset = converted.getTimezoneOffset();
        converted.setTime(converted.getTime() + (offset * 60 * 1000));
        return converted;
    }
}

export class CreateJobDto {
    public id: string;
    public userId: string;
    public name: string;
    public jobType: JobType;
    public projectId: string;

    public start: string;
    public end: string;
    public timeZoneId: string;
    public schedule: Schedule;

    public locations: Position[];
    public minimumSectionLength: number;

    public startAddress: string;
    public endAddress: string;

    public status: JobStatus;
    public createdAt: Date;

    constructor(job: Job) {
        this.id = job.id;
        this.userId = job.userId;
        this.name = job.name;
        this.jobType = job.jobType;
        this.projectId = job.projectId;

        let startMonth = (job.start.getMonth() + 1);
        let startMonthStr = startMonth < 10 ? '0' + startMonth : startMonth;
        let startday = job.start.getDate() < 10 ? '0' + job.start.getDate() : job.start.getDate();

        let endMonth = (job.end.getMonth() + 1);
        let endMonthStr = endMonth < 10 ? '0' + endMonth : endMonth;
        let endday = job.end.getDate() < 10 ? '0' + job.end.getDate() : job.end.getDate();

        this.start = job.start.getFullYear() + '-' + startMonth + '-' + startday + 'T00:00:00Z';
        this.end = job.end.getFullYear() + '-' + endMonthStr + '-' + endday + 'T00:00:00Z';

        this.timeZoneId = job.timeZoneId;
        this.schedule = job.schedule;
        this.locations = job.locations;
        this.minimumSectionLength = job.minimumSectionLength;
        this.startAddress = job.startAddress;
        this.endAddress = job.endAddress;
        this.status = job.status;
        this.createdAt = job.createdAt;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/job.ts